import Navbar from "@/components/Navbar";
import Courses from "@/components/Courses";
import YoutubeShowcase from "@/components/YoutubeShowcase";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import BookingModal from "@/components/BookingModal";
import { useLenis, useHashScroll } from "@/hooks/usePageUtils";

const CoursesPage = () => {
  useLenis();
  useHashScroll();

  return (
    <>
      <Navbar />
      <main className="pt-24">
        <Courses />
        <YoutubeShowcase />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <BookingModal />
    </>
  );
};

export default CoursesPage;
